module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination",
    class: _vm.paginationClass
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.value === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.range(_vm.minPage, _vm.maxPage)), function(item) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        active: _vm.value === item
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.changePage(item)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-pre",
    class: {
      disabled: _vm.value === _vm.totalPages
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Next"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Previous"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1461ae2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Pagination.vue
// module id = 529
// module chunks = 55